export default "__VITE_ASSET__CPaE77MH__"